module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-4.bf115ed7.jpg";